import type { PaymentAction, PaymentActionsType, ResultCode } from "@adyen/adyen-web";
type ParsedPaymentAction = {
    action: PaymentAction;
    resultCode: ResultCode;
};

// Every action type createAdyenInstance.ts's onSubmit switch actually handles. Typed as
// Record<PaymentActionsType, true> so adding a new Adyen action type without also handling it
// here is a type error, not something that silently falls through the switch at runtime.
const SUPPORTED_ACTION_TYPES: Record<PaymentActionsType, true> = {
    redirect: true,
    threeDS2: true,
    sdk: true,
    qrCode: true,
    voucher: true,
    bankTransfer: true,
    await: true,
};

const isSupportedActionType = (type: unknown): type is PaymentActionsType =>
    typeof type === "string" && Object.prototype.hasOwnProperty.call(SUPPORTED_ACTION_TYPES, type);

// Parse action from API response. API responds with actions as stringified JSON. A response can
// be valid JSON with a resultCode but no usable action (e.g. a truthy non-string type, or a
// string type onSubmit's switch doesn't handle) — treat that the same as no action at all,
// rather than returning something callers would otherwise treat as "action to handle".
export const parsePaymentAction = (jsonString?: string): ParsedPaymentAction | undefined => {
    if (!jsonString) {
        return;
    }
    const parsed = JSON.parse(jsonString) as { action?: { type?: unknown } } | null;
    if (!isSupportedActionType(parsed?.action?.type)) {
        return undefined;
    }
    return parsed as ParsedPaymentAction;
};
